import reportInstance from '../instance'

export const getRecordsFormatZDateVZip = (dateFrom, dateTo) => {
	return reportInstance.get('/zdatev/zip?'
		+ (dateFrom ? 'dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''),
		{ responseType: 'arraybuffer' })
}

export default getRecordsFormatZDateVZip
